module.exports = __webpack_public_path__ + "media/七元 - Love You Like A Love Song (新版).99a7f444.mp3";